/* eslint-disable react/prop-types */
/* eslint-disable no-bitwise */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
  Grid,
  Box,
  Tag,
  Spacer,
  Text,
  Button,
  DropDown,
  Tabs,
  Modal,
  ModalBody,
  ModalClose,
  ModalFooter,
  StatusIndicator,
} from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import { getCountry } from 'country-state-picker';
import {
  errorNotifier,
  stringToHslColor,
  successNotifier,
} from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import {
  fetchApplicantFormStart,
  fetchFormSchemaStart,
} from 'redux/applicants/actions';
import { fetchCandidateEmails } from 'redux/applicants/actions';
import {
  selectLoadingApplicantForm,
  selectLoadingFormSchema,
  selectFormSchema,
  selectApplicantForm,
} from 'redux/applicants/selector';
import {
  orgBranches,
  selectPortalSettings,
} from 'redux/configurations/selectors';
import request from 'utils/request';
import urls from 'utils/config';

import { processForm, processFormFiles } from 'utils/processFormUtil';
import AttachmentsTab from '../ApplicantTabs/AttachmentsTab';
import CanView, { Permissions } from 'components/CanView';
import {
  selectOrgAliases,
  selectInstitution,
} from 'redux/configurations/selectors';
import ChangeStatusModal from './changeStatusModal';
import ActivityLog from '../ApplicantTabs/ActivityLog';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { ChangeCourseModal } from './ChangeCourseModal';
import { EditApplicantDetails } from './EditApplicantDetails';
import EmailTab from '../ApplicantTabs/EmailTab';
import { SendMailModal } from './SendMailModal';

import TransactionTab from '../ApplicantTabs/TransactionsTab';
import { SideModal } from 'components/styles/applicantModal.style';
import { EMPTY_VALUE } from 'utils/constants';
import { stepTypeColor, stepTypeIcon } from 'components/WorkflowSteps/utils';
// ! commented out NECO incase it might be brought back
// import NecoResult from './NecoResult';
import NinResult from './NinResult';

import FormPdf from '../PdfDownloads/ApplicantFormDownload';
import PostApplicantModal from './postApplicantModal';
import { formatApplicantDate } from '../utils';
// import CriteriaMet from '../ApplicantTabs/CriteriaMet';
import RefereeTab from '../ApplicantTabs/Referee';
import { getLocalUser } from 'utils/helpers';
import {
  hasAccessToStep,
  getUserRoleIds,
  filterAccessibleSteps,
  isSuperUser,
} from 'utils/workflowAccess';

const moment = require('moment-timezone');
const { API_BASE_URL, FORM_DATA_REPOSITORY } = urls || {};



export const getColumnStructure = (len) => {
  const colStructure = Array.from(len).map(() => '1fr');
  if (colStructure.length === 2) {
    colStructure.push('1fr');
  }
  return colStructure.join(' ');
};

export const formatAddress = (val) => {
  if (typeof val === 'string') return val;

  return (val || [])?.reverse()?.join(' LGA of ');
};

export const formatCountry = (val) => {
  const findCountry = getCountry(val || '');
  return findCountry?.name || val;
};

export const SingleApplicantModal = (props) => {
  const { params } = useRouteMatch();
  const dispatch = useDispatch();
  const branches = useSelector(orgBranches);
  const institution = useSelector(selectInstitution);
  const aliases = useSelector(selectOrgAliases);
  const formLoading = useSelector(selectLoadingApplicantForm);
  const loadingFormSchema = useSelector(selectLoadingFormSchema);
  const _formData = useSelector(selectApplicantForm);
  const formData = props.applicantForm || _formData;
  const _formSchema = useSelector(selectFormSchema);
  const formSchema = props.applicantFormSchema || _formSchema
  const { contacts } = useSelector(selectPortalSettings);

  const [formItem, setFormItem] = useState([]);
  const [candidateAttachmentsSummary, setCandidateAttachmentsSummary] =
    useState([]);
  const [formItemData, setFormItemData] = useState({});
  const [referees, setReferees] = useState([]);
  const [max, SetMax] = useState(false);

  const [showOffer, setShowOffer] = useState(false);

  const [changeCourse, setChangeCourse] = useState(false);
  const [changingCourse, setChangingCourse] = useState(false);
  const [showEditApplication, setShowEditApplication] = useState(false);
  const [showPostApplicant, setShowPostApplicant] = useState(false);

  const [commentModal, setCommentModal] = useState(false);
  const [stageToProcess, setStageToProcess] = useState(null);
  const [sendMail, setSendMail] = useState({
    open: false,
    stage: '',
    applicants: [],
    singleApplicant: true,
  });

  // Get user and extract role IDs for workflow access control
  const [userRoleIds, setUserRoleIds] = useState([]);
  const [userIsSuperUser, setUserIsSuperUser] = useState(false);
  useEffect(() => {
    try {
      const userStr = getLocalUser();
      if (userStr) {
        const user = JSON.parse(userStr);
        const roleIds = getUserRoleIds(user);
        const superUserCheck = isSuperUser(user);
        setUserRoleIds(roleIds);
        setUserIsSuperUser(superUserCheck);
      }
    } catch (error) {
      // If user parsing fails, userRoleIds remains empty array
      setUserRoleIds([]);
      setUserIsSuperUser(false);
    }
  }, []);

  // Check if user has access to candidate's current step
  const hasAccessToCurrentStep = useMemo(() => {
    if (!props.applicant || !props.application?.workflow?.steps) {
      return false;
    }
    const currentStep = props.application.workflow.steps.find(
      step => step.id === props.applicant.stageId
    );
    if (!currentStep) {
      return false;
    }
    return hasAccessToStep(currentStep, userRoleIds, userIsSuperUser);
  }, [props.applicant, props.application, userRoleIds, userIsSuperUser]);

  // Filter accessible workflow steps
  const accessibleSteps = useMemo(() => {
    if (!props.application?.workflow?.steps) {
      return [];
    }
    return filterAccessibleSteps(props.application.workflow.steps, userRoleIds, userIsSuperUser);
  }, [props.application, userRoleIds, userIsSuperUser]);

  // Check if Process Application button should be disabled
  const isProcessApplicationDisabled = useMemo(() => {
    // Also disable if no steps are available at all
    if (!props.application?.workflow?.steps || props.application.workflow.steps.length === 0) {
      return true;
    }
    
    // If user has no access to current step AND no access to any target steps, disable button
    // But if user has access to at least one step (current or target), enable the button
    const hasAnyAccess = hasAccessToCurrentStep || accessibleSteps.length > 0;
    
    return !hasAnyAccess;
  }, [hasAccessToCurrentStep, accessibleSteps, props.application]);

  // ! commented out NECO incase it might be brought back
  // const [necoInfo, setNecoInfo] = useState([]);
  // const [loadingNecoInfo, setLoadingNecoInfo] = useState(true);
  const [ninInfo, setNinInfo] = useState([]);
  const [loadingNinInfo, setLoadingNinInfo] = useState(false);

  const hasNinAddon = Boolean(
    props?.application?.addonIds?.find((addon) => addon === 'nin')
  );
  const applicantId = props?.applicant?.id;

  useEffect(() => {
    // Form Data Service submission ids are Mongo ObjectIds (24 hex), not UUIDs.
    // Form Builder design ids (application/course formId) are typically UUIDs.
    const isUuid = (value) =>
      typeof value === 'string' &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        value
      );
    const isMongoObjectId = (value) =>
      typeof value === 'string' && /^[0-9a-f]{24}$/i.test(value);
    const isValidFormDataId = (value) =>
      typeof value === 'string' &&
      !value.startsWith('seed-form-') &&
      (isUuid(value) || isMongoObjectId(value));

    if (props.applicant?.formId && isValidFormDataId(props.applicant.formId)) {
      dispatch(fetchApplicantFormStart(props.applicant.formId));
      const getMatchingCourse = props?.application?.courses?.find(
        (data) => data?.course?.id === props?.applicant?.course?.id
      );
      const schemaId =
        getMatchingCourse && isUuid(getMatchingCourse.formId)
          ? getMatchingCourse.formId
          : props?.application?.formId;
      if (isUuid(schemaId)) {
        dispatch(fetchFormSchemaStart(schemaId));
      }
    }
    // ! commented out NECO incase it might be brought back
    // fetchNecoResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.applicant?.formId]);

  useEffect(() => {
    const fetchNinResult = async () => {
      if (!hasNinAddon || !applicantId) {
        setNinInfo([]);
        return;
      }
      setLoadingNinInfo(true);
      const url = `${API_BASE_URL}/addons/nin/result/${applicantId}`;
      try {
        const response = await request({ method: 'get', url });
        if (response.success) {
          setNinInfo(response.raw || []);
        } else {
          setNinInfo([]);
        }
      } catch (err) {
        setNinInfo([]);
      } finally {
        setLoadingNinInfo(false);
      }
    };
    fetchNinResult();
  }, [hasNinAddon, applicantId]);

  useEffect(() => {
    if (formSchema) {
      const processed = processForm(
        formSchema,
        formData?.data?.duplicateFields || {}
      );
      setFormItem(processed);
    }
  }, [formSchema, formData]);

  const fetchAttachmentFile = async (attachmentId) => {
    if (!props.candidate) Promise.resolve();
    const url = `${FORM_DATA_REPOSITORY}/forms/${props.applicant?.formId}/attachments/${attachmentId}`;
    return request({ method: 'get', url, responseType: 'blob' });
  };

  const handleChangeCourse = async (applicantId, courseId) => {
    if (!applicantId || !courseId) {
      return;
    }
    setChangingCourse(true);
    const url = `${API_BASE_URL}/candidates/${applicantId}`;
    try {
      const res = await request({ method: 'patch', url, data: { courseId } });
      if (props.updateApplicant) {
        props.updateApplicant({ ...props.applicant, ...res.raw });
      }
      setChangeCourse(false);
      successNotifier('Course changed successfully');
      if (props.setRefetchCandidates) {
        props.setRefetchCandidates(true);
      }
    } catch (error) {
      errorNotifier(error.message || 'Unable to change course');
    } finally {
      setChangingCourse(false);
    }
  };

  useEffect(() => {
    if (formSchema && formData) {
      const attachmentsByKey = {};
      (formData?.attachments || []).forEach((a) => {
        attachmentsByKey[a.name.split('Z-').reverse()[0]] = a;
      });

      const candidateAttachments = [];
      processFormFiles(formSchema, formData?.data?.duplicateFields).forEach(
        (fileData) => {
          if (attachmentsByKey[fileData.id]) {
            candidateAttachments.push({
              ...fileData,
              ...attachmentsByKey[fileData.id],
              attachmentId: attachmentsByKey[fileData.id].id,
            });
          }
          if (formData?.data[fileData.id]) {
            candidateAttachments.push({
              ...fileData,
              data: formData?.data[fileData.id],
            });
          }
        }
      );
      setCandidateAttachmentsSummary(candidateAttachments);
    }
  }, [formData, formSchema]);

  useEffect(() => {
    if (formData) {
      const newFormValues = { ...formData.data };
      (formData?.attachments || []).forEach((a) => {
        const arrVal = a.name.split('-');
        arrVal.forEach((a, i) => {
          if (a.includes(':')) {
            arrVal.splice(0, i + 1);
          }
        });
        newFormValues[arrVal.join('-')] = [
          { ...a, type: a.mimetype, saved: true },
        ];
      });
      setFormItemData({ ...newFormValues });
    }
  }, [formData]);

  // When NIN addon is on, fill empty BIO DATA fields from nin_result for display.
  useEffect(() => {
    if (!hasNinAddon || !ninInfo?.length) {
      return;
    }
    const latest = ninInfo[ninInfo.length - 1]?.result || ninInfo[ninInfo.length - 1];
    if (!latest) {
      return;
    }
    const formatDob = (value) => {
      if (value == null || value === '') return null;
      if (Array.isArray(value) && value.length >= 3) {
        const [y, m, d] = value;
        return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`;
      }
      if (typeof value === 'string') {
        const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
        return value;
      }
      return null;
    };
    const normalizeGender = (value) => {
      if (value == null || value === '') return null;
      const token = String(value).trim().toLowerCase();
      if (token.startsWith('f') || token.includes('female')) return 'FEMALE';
      if (token.startsWith('m') || token.includes('male')) return 'MALE';
      return String(value).trim().toUpperCase();
    };
    const isBlank = (v) =>
      v == null ||
      v === '' ||
      v === EMPTY_VALUE ||
      v === '--/--' ||
      (typeof v === 'string' && v.trim() === '');

    const bio = {
      gender: normalizeGender(latest.gender),
      sex: normalizeGender(latest.gender),
      date_of_birth: formatDob(latest.dateOfBirth),
      dob: formatDob(latest.dateOfBirth),
      dateOfBirth: formatDob(latest.dateOfBirth),
      nin: latest.ninLast4 ? `****${latest.ninLast4}` : null,
      nin_number: latest.ninLast4 ? `****${latest.ninLast4}` : null,
      first_name: latest.firstName || null,
      firstName: latest.firstName || null,
      middle_name: latest.middleName || null,
      middleName: latest.middleName || null,
      last_name: latest.lastName || null,
      lastName: latest.lastName || null,
      state_of_origin: latest.state || null,
      state: latest.state || null,
      lga_of_origin: latest.lga || null,
      lga: latest.lga || null,
    };

    setFormItemData((prev) => {
      if (!prev || Object.keys(prev).length === 0) {
        // Still seed common keys so BIO DATA can show values even if form map is sparse.
        const seeded = { ...prev };
        let changed = false;
        Object.entries(bio).forEach(([k, v]) => {
          if (v != null && isBlank(seeded[k])) {
            seeded[k] = v;
            changed = true;
          }
        });
        return changed ? seeded : prev;
      }
      const next = { ...prev };
      let changed = false;
      Object.keys(next).forEach((key) => {
        if (!isBlank(next[key])) return;
        const normalized = String(key).trim().toLowerCase().replace(/\s+/g, '_');
        let value = bio[key] || bio[normalized] || null;
        if (!value) {
          if (normalized.includes('gender') || normalized === 'sex') value = bio.gender;
          else if (normalized.includes('date_of_birth') || normalized === 'dob' || (normalized.includes('birth') && normalized.includes('date')))
            value = bio.date_of_birth;
          else if (normalized === 'nin' || normalized.includes('nin_number') || normalized.includes('national_identification'))
            value = bio.nin;
          else if (normalized.includes('first_name') || normalized === 'firstname') value = bio.first_name;
          else if (normalized.includes('middle_name') || normalized === 'middlename') value = bio.middle_name;
          else if (normalized.includes('last_name') || normalized === 'lastname' || normalized.includes('surname'))
            value = bio.last_name;
          else if (normalized.includes('state')) value = bio.state_of_origin;
          else if (normalized.includes('lga')) value = bio.lga_of_origin;
        }
        if (value != null) {
          next[key] = value;
          changed = true;
        }
      });
      // Ensure common aliases exist for schema field ids that match map keys exactly.
      Object.entries(bio).forEach(([k, v]) => {
        if (v != null && isBlank(next[k])) {
          next[k] = v;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [hasNinAddon, ninInfo, formData]);

  useEffect(() => {
    if (props.applicant?.referees?.length && formSchema) {
      const processed = props?.applicant?.referees.map((referee) =>
        processForm(formSchema, referee?.data?.duplicateFields || {})
      );
      const refInfo = {};
      processed.forEach((ref, i) => {
        const filteredInput = ref?.filter(
          (r) => r?.refereeSectionType?.toLowerCase() === 'referee'
        );
        const extractInput = filteredInput.map((filt) => filt?.inputs);
        refInfo[i] = extractInput;
      });
      setReferees(
        props.applicant?.referees.map((ref, i) => ({
          ...ref,
          inputs: refInfo[i]?.flat(),
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.applicant, formSchema, formData]);

  // ! commented out NECO incase it might be brought back
  // const fetchNecoResult = async () => {
  //   setLoadingNecoInfo(true);
  //   const url = `${API_BASE_URL}/addons/neco/result/${props?.applicant?.id}`;
  //   const response = await request({ method: 'get', url });
  //   if (response.success) {
  //     setLoadingNecoInfo(false);
  //     setNecoInfo(response.raw);
  //   } else {
  //     setLoadingNecoInfo(false);
  //     return;
  //   }
  // };

  const handleEditApplicantSuccess = (data) => {
    dispatch(fetchApplicantFormStart(props.applicant.formId));
    props.onEditApplicantSuccess(data);
    props.setRefetchCandidates(true);
  };

  const handleRefereeUpdated = async () => {
    const url = `${API_BASE_URL}/candidates/${props.applicant?.id}`;
    try {
      const res = await request({ method: 'get', url });
      if (res.success && res.raw) {
        handleEditApplicantSuccess(res.raw);
      }
    } catch (err) {
      errorNotifier(err?.message || 'Failed to refresh applicant');
    }
  };

  // ! commented out NECO incase it might be brought back
  // const hasNecoAddon = () => {
  //   const foundNecoAddon = props?.application?.addonIds.find(
  //     (addon) => addon === 'neco'
  //   );
  //   return foundNecoAddon;
  // };

  const CanRunActions = (list) => list.filter((item) => item.can);

  const pdfFormRef = useRef(null);

  const handleDownloadForm = useReactToPrint({
    content: () => pdfFormRef.current,
  });

  return (
    <>
      <SideModal
        onClose={() => {
          props.setModal(false);
          setFormItem([]);
          setFormItemData({});
          setReferees([]);
        }}
        open={props.open}
        max={max}
        setMax={() => SetMax(!max)}
      >
        <div className="side-container">
          {formLoading || loadingFormSchema ? (
            <Box width="100%" className="applicant-info-loader" vAlign>
              <Box width="100%" margin="10px 20px" align="center">
                <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
                  <Skeleton count={max ? 13 : 5} height={40} />
                </SkeletonTheme>
              </Box>
            </Box>
          ) : (
            <>
              <div className="applicant-info">
                <div className="applicant-info-details">
                  <Box>
                    <Text bold block size="20px">
                      {props?.applicant?.firstName}{' '}
                      {props?.applicant?.middleName}{' '}
                      {props?.applicant?.lastName}
                    </Text>
                    <Spacer space="8px" />
                    <Text bold>Application Number:</Text>
                    <Text>{props?.applicant?.applicationNumber}</Text>
                    <Spacer inline direction="horizontal" />
                    <Spacer className="show-on-mini" />
                    <StatusIndicator
                      label={
                        props?.application?.workflow?.steps?.find(
                          (st) => st.id === props?.applicant?.stageId
                        )?.name || ''
                      }
                      color={
                        stepTypeColor[
                          props?.application?.workflow?.steps?.find(
                            (st) => st.id === props?.applicant?.stageId
                          )?.type
                        ] || Theme.PrimaryYellow
                      }
                      compound
                    />
                  </Box>
                  <Spacer space="8px" />
              
                  <div style={{ display: 'none' }}>
                    <FormPdf
                      data={{
                        data: props?.applicant || null,
                        org: props?.institution || null,
                        formItem: formItem || [],
                        formItemData: formItemData || {},
                        necoInfo: [],
                        alias: aliases,
                        timezone: institution?.timeZone,
                        contacts,
                      }}
                      pdfFormRef={pdfFormRef}
                    />
                  </div>

                  <Button
                    iconLeft={<i className="saf-download" />}
                    onClick={handleDownloadForm}
                  >
                    Download Applicant Form
                  </Button>
                </div>
                <div className="flex-div applicant-info-actions">
                  {
                    <Box margin="0 0 0 auto" align="right">
                      <CanView can={[Permissions.UPDATE_CANDIDATES]}>
                        <DropDown
                          trigger="click"
                          disabled={isProcessApplicationDisabled}
                          label={
                            <Button width={150} disabled={isProcessApplicationDisabled}>
                              Process Application
                            </Button>
                          }
                        >
                          {accessibleSteps.map((step) => (
                            <li key={step.id}>
                              <Button
                                onClick={() => {
                                  setCommentModal(true);
                                  setStageToProcess(step);
                                }}
                                color={
                                  stepTypeColor[step.type] || Theme.PrimaryGreen
                                }
                                disabled={props.applicant?.stageId === step.id}
                                block
                                iconLeft={
                                  <i
                                    className={
                                      stepTypeIcon[step.type] || 'saf-star'
                                    }
                                  />
                                }
                              >
                                {step.name}
                              </Button>
                            </li>
                          ))}
                        </DropDown>
                      </CanView>
                    </Box>
                  }
                  <Box>
                    <DropDown
                      trigger="click"
                      menuAlign="bottom right"
                      label={
                        <Button
                          width={130}
                          pale
                          iconRight={<i className="saf-down-open" />}
                        >
                          More actions
                        </Button>
                      }
                      menuList={CanRunActions([
                        {
                          onClick: () => setChangeCourse(true),
                          label: `Change ${aliases?.course}`,
                          iconLeft: 'saf-switch',
                          can: true,
                        },
                        {
                          onClick: () => setShowEditApplication(true),
                          label: 'Edit Applicant',
                          iconLeft: 'saf-edit',
                          can: true,
                        },
                        {
                          onClick: () => setShowPostApplicant(true),
                          label: `${
                            props.applicant?.location?.id
                              ? `Change Applicant Posting`
                              : `Post Applicant`
                          }`,
                          iconLeft: 'saf-edit',
                          can: branches.data.length > 0 ? true : false,
                        },
                      ])}
                    />
                  </Box>
                </div>
              </div>
              <div className="applicant-detail">
                <div className="applicant-detail-info">
                  <Box>
                    <Text bold uppercase>
                      Application:{' '}
                    </Text>
                    <Text
                      size="14px"
                      capitalize
                      color={Theme.PrimaryColor}
                      bold
                    >
                      <NavLink
                        to={`/${params.orgName}/manage-applications/${props.application?.id}`}
                      >
                        {' '}
                        {props.applicant?.applicationTitle}{' '}
                      </NavLink>
                    </Text>
                  </Box>
                  <Box>
                    <Text bold uppercase>
                      {aliases?.course} Code:
                    </Text>{' '}
                    <Text uppercase>{props.course?.code}</Text>
                  </Box>
                  <Box>
                    <Text bold uppercase>
                      {aliases?.course}:
                    </Text>{' '}
                    <Text uppercase>{props?.course?.title}</Text>
                  </Box>
                  {props.applicant?.location?.id && (
                    <Box>
                      <Text bold uppercase>
                        Posted to:
                      </Text>{' '}
                      <Text>
                        <Text>{props.applicant?.location?.name}</Text>
                      </Text>
                    </Box>
                  )}
                  <Box>
                    {props.application?.applicationGroupItems?.map(
                      (group, i) => (
                        <Tag
                          key={i}
                          height={25}
                          font="12px"
                          style={{ border: 'none' }}
                          color={stringToHslColor(group.groupId, 100, 30)}
                          fontColor={stringToHslColor(group.groupId, 30, 40)}
                        >
                          {group.name}
                        </Tag>
                      )
                    )}
                  </Box>
                </div>
                <div className="applicant-detail-photo">
                  {formItemData?.passport_picture && (
                    <Box className="applicant-detail-photo-container">
                      <img
                        src={formItemData?.passport_picture}
                        alt="Passport"
                      />
                    </Box>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="application-detail">
            {formLoading ? (
              <Box width="100%" className="application-detail-loader" vAlign>
                <Box width="100%" margin="10px 20px" align="center">
                  <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
                    <Skeleton count={max ? 20 : 13} height={40} />
                  </SkeletonTheme>
                </Box>
              </Box>
            ) : (
              <Box pad="20px" className="view-applicant-box">
                {hasNinAddon && (
                  <NinResult loading={loadingNinInfo} ninInfo={ninInfo} />
                )}
                {props.applicant?.formId && (
                  <Tabs responsive={-1} background="#fff">
                    {[
                      {
                        label: 'Application Information',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <>
                            {props?.applicant?.accountEmail && (
                              <Box align="right" margin="10px 24px">
                                <Text size="14px">
                                  Submitted By: {props?.applicant?.accountEmail}
                                </Text>
                              </Box>
                            )}
                            <Box className="applicant-infox">
                              {formItem
                                .filter((item) => +item.inputs?.length > 0)
                                .filter(
                                  (item) =>
                                    item?.refereeSectionType?.toLowerCase() !==
                                    'referee'
                                )
                                .map((item, i) => (
                                  <Box className="applicant-infox-row" key={i}>
                                    <Text
                                      block
                                      bold
                                      capitalize
                                      size="16px"
                                      uppercase
                                      className="applicant-infox-row-header"
                                    >
                                      {item?.title}
                                    </Text>
                                    {item?.inputs?.map((eachRow, rowIndex) => (
                                      <Grid
                                        className="form-grid"
                                        default={getColumnStructure(eachRow)}
                                        gap="10px"
                                        key={`row-${rowIndex}`}
                                      >
                                        {eachRow.map((eachField, i) => (
                                          <Box key={i} className="single-form">
                                            <Text
                                              color={({ theme }) =>
                                                theme.PrimaryInputOutline
                                              }
                                              uppercase
                                              bold
                                              block
                                            >
                                              {eachField?.title}
                                            </Text>

                                            {eachField?.source ===
                                            'nigeria-states-lga' ? (
                                              <Text
                                                capitalize
                                                size="15px"
                                                block
                                              >
                                                {formatAddress(
                                                  formItemData?.[eachField?.id]
                                                )}
                                              </Text>
                                            ) : eachField?.source ===
                                              'countries' ? (
                                              <Text
                                                capitalize
                                                size="15px"
                                                block
                                              >
                                                <p>
                                                  {formatCountry(
                                                    formItemData?.[
                                                      eachField?.id
                                                    ]
                                                  )}
                                                </p>
                                              </Text>
                                            ) : (
                                              <Text
                                                capitalize={
                                                  ![
                                                    'email',
                                                    'wysiwyg',
                                                  ].includes(
                                                    eachField?.type?.toLowerCase()
                                                  )
                                                }
                                                size="15px"
                                                block
                                              >
                                                {eachField?.type ===
                                                'checkbox' ? (
                                                  <>
                                                    {formItemData?.[
                                                      eachField.id
                                                    ]
                                                      ? eachField.trueDisplay
                                                      : eachField.falseDisplay}
                                                  </>
                                                ) : (
                                                  <>
                                                    {[
                                                      'date',
                                                      'single-date',
                                                    ].includes(
                                                      eachField?.type?.toLowerCase()
                                                    ) &&
                                                    formItemData?.[
                                                      eachField?.id
                                                    ] ? (
                                                      <p>
                                                        {moment(
                                                          formatApplicantDate(
                                                            formItemData?.[
                                                              eachField?.id
                                                            ]
                                                          )
                                                        ).format(
                                                          'MMMM Do YYYY'
                                                        )}
                                                      </p>
                                                    ) : (
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            formItemData?.[
                                                              eachField?.id
                                                            ] || EMPTY_VALUE,
                                                        }}
                                                      />
                                                    )}
                                                  </>
                                                )}
                                              </Text>
                                            )}
                                          </Box>
                                        ))}
                                      </Grid>
                                    ))}
                                  </Box>
                                ))}
                            </Box>
                          </>
                        ),
                        icon: <i className="saf-sliders" />,
                        show: true,
                        disabled: false,
                      },
                      {
                        label: 'Referee',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <RefereeTab
                            referees={referees}
                            onRefereeUpdated={handleRefereeUpdated}
                          />
                        ),
                        icon: <i className="saf-users-outline" />,
                        show: referees?.length ? true : false,
                        disabled: false,
                      },
                      {
                        label: 'Attachments',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <AttachmentsTab
                            attachments={candidateAttachmentsSummary}
                            fetchFile={fetchAttachmentFile}
                            modalSize={max}
                          />
                        ),
                        icon: <i className="saf-attach" />,
                        show: candidateAttachmentsSummary?.length
                          ? true
                          : false,
                        disabled: false,
                      },
                      {
                        label: 'Offer Letter',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <Box margin="20px 0 20px 0">
                            <Grid default={!max ? '1fr' : '1fr 1fr'} gap="20px">
                              <Box
                                margin="30px 0"
                                pad="12px 25px"
                                background={({ theme }) => theme.PrimaryFade}
                                style={{ borderRadius: '3px' }}
                              >
                                <Grid
                                  default="3fr 2fr 1fr 80px"
                                  style={{ alignItems: 'center' }}
                                >
                                  <Text uppercase bold size="13px">
                                    Admission Letter
                                  </Text>
                                  <Text>
                                    <b>Section</b>: Educational information
                                  </Text>
                                  <Text>
                                    <b>Size</b>: 45.21KB
                                  </Text>
                                  <Button
                                    onClick={() => setShowOffer(true)}
                                    pale
                                  >
                                    Preview
                                  </Button>
                                </Grid>
                              </Box>
                            </Grid>
                          </Box>
                        ),
                        icon: <i className="saf-file-pdf" />,
                        show: props?.applicant?.letter ? true : false,
                        disabled: !props?.applicant?.letter,
                      },
                      {
                        label: 'Email',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <EmailTab
                            applicant={props?.applicant}
                            sendEmail={() =>
                              setSendMail({
                                ...sendMail,
                                open: true,
                                stage: props?.applicant?.stage,
                                applicants: [props?.applicant],
                              })
                            }
                          />
                        ),
                        icon: <i className="saf-mail" />,
                        show: true,
                        disabled: false,
                      },
                      {
                        label: 'Activity Log',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <ActivityLog
                            applicant={props.applicant}
                            workflowSteps={props?.application?.workflow?.steps}
                          />
                        ),
                        icon: <i className="saf-sliders" />,
                        show: true,
                        disabled: false,
                      },
                      {
                        label: 'Transactions',
                        // eslint-disable-next-line react/display-name
                        component: () => (
                          <TransactionTab
                            applicant={props?.applicant}
                            modalSize={max}
                          />
                        ),
                        icon: <i className="saf-history" />,
                        show: true,
                        disabled: false,
                      },
                      /* {
                        label: 'Criteria Met',
                        // eslint-disable-next-line react/display-name
                        component: () => <CriteriaMet />,
                        icon: <i className="saf-check" />,
                        show: true,
                        disabled: false,
                      }, */
                    ]
                      .filter((elem) => elem.show)
                      .map((elem, i) => (
                        <div
                          key={i}
                          label={elem.label}
                          iconRight={elem.icon}
                          disabled={elem.disabled}
                        >
                          {elem.component(i)}
                        </div>
                      ))}
                  </Tabs>
                )}
              </Box>
            )}
          </div>
        </div>
      </SideModal>
      <ChangeStatusModal
        changeStatus={commentModal}
        handleModal={setCommentModal}
        stageToProcess={stageToProcess}
        applicant={props.applicant}
        application={props.application}
        course={props.selectedCourse}
        setRefetchCandidates={props.setRefetchCandidates}
        closeModals={() => {
          setCommentModal(false);
          props.setModal(false);
        }}
        workflowDetails={props?.workflowDetails}
      />
      <PostApplicantModal
        open={showPostApplicant}
        handleModal={setShowPostApplicant}
        applicant={props.applicant}
        setRefetchCandidates={props.setRefetchCandidates}
        closeModals={() => {
          setShowPostApplicant(false);
        }}
        updateApplicant={props.updateApplicant}
      />
      <ChangeCourseModal
        open={changeCourse}
        close={() => setChangeCourse(false)}
        application={props.application}
        applicant={props.applicant}
        onChange={handleChangeCourse}
        changingCourse={changingCourse}
      />
      {showEditApplication && (
        <EditApplicantDetails
          formId={props.applicant?.formId}
          candidateId={props.applicant?.id}
          open={showEditApplication}
          close={() => setShowEditApplication(false)}
          onSuccess={(res) => handleEditApplicantSuccess(res)}
          formItem={formItem}
          formItemData={formItemData}
          formDataId={formItem?.id}
          applicant={props.applicant}
          application={props.application}
          course={props.selectedCourse}
          data={props.applicant}
          formSchema={formSchema}
          duplicateFields={formData?.data?.duplicateFields || {}}
          candidateAttachmentsSummary={candidateAttachmentsSummary}
        />
      )}
      <CanView can={[Permissions.CREATE_EMAIL]}>
        <SendMailModal
          emailState={sendMail}
          application={props?.application}
          handleModal={() =>
            setSendMail({ open: false, stage: '', applicants: [] })
          }
          callBack={() => dispatch(fetchCandidateEmails(props?.applicant?.id))}
        />
      </CanView>
      <Modal outerclick onClose={() => setShowOffer(false)} open={showOffer}>
        <ModalBody style={{ height: 'fit-content' }} width="80vw">
          <ModalClose onClick={() => setShowOffer(false)}>&times;</ModalClose>
          <Box pad="20px">
            <h2>Admission letter</h2>
            <Spacer />
            <object
              width="100%"
              height="1000"
              data={`${props?.applicant?.letter}?b=${new Date().getTime()}`}
              type="application/pdf"
            >
              {' '}
            </object>
          </Box>
          <ModalFooter>
            <Box width="min-content" pad="20px" margin=" 0 0 0  auto">
              <Button onClick={() => setShowOffer(false)} spaceLeft="auto" pale>
                Close
              </Button>
            </Box>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  );
};
